/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.20.1.0 (NJsonSchema v9.11.0.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export interface SearchResultDTO
{
  searchResult?: SearchResult;
}

export interface RecordsResult
{
  records?: Record[];
  paging?: Paging;
  searchQuery?: SearchQuery;
  error?: string;
}

export interface InputDTO
{
  customerID: string
  customerAuthorizationToken: string
}

export interface ProductFamilyGetDTO extends InputDTO
{
  productFamilyCode: string
  recommendationID: string
  recommendationContext: string
}

export interface SearchResult extends RecordsResult
{
  //iD: number;
  recordsPerPage?: RecordsPerPage[];
  filters?: Filter[];
  sorts?: Sort[];
  filterOptions?: FilterOptions;
  recommendationID: string;
  settings?: Settings;
  description?: string;
  descriptionExtension?: string;
  activeFilters?: Filter[];
  title?: string;
  header?: string;
}

export interface RecordsPerPage
{
  value: number;
  default: boolean;
  selected: boolean;
  link?: string;
}

export interface Filter
{
  code?: string;
  index: number;
  hint?: string;
  unit?: string;
  description?: string;
  showSearch?: boolean;
  name?: string;
  type?: string;
  view?: string;
  advanced: boolean;
  linkTemplate?: string;
  values?: FilterElement[];
  selectedValues?: FilterElement[];
  selectedInterval?: Interval;
  showRealLinks?: boolean;
  global?: Interval;
  local?: Interval;
  changeExpand?: boolean;
  intervalStep?: number;
  intervalScale?: number;
  intervalBase?: number;
  multiselectConjunction?: string;
  intervalQuantiles?: number[];
  innerFilters?: Filter[];
  intervalRecordCount?: { [key: string]: number };
  filterHidden: boolean;
  defaultExpanded: boolean;
  mainFilter?: boolean;
}

export interface FilterElement
{
  code?: string;
  iD?: number;
  value?: string;
  selected?: boolean;
  recordCount?: number;
  imageUrl?: string;
  link?: string;
  color?: string;
  colorSelected?: string;
}

export interface Interval
{
  min: number;
  max: number;
}

export interface Sort
{
  code?: string;
  name?: string;
  ascending: boolean;
  field?: string;
  sortType?: string;
  link?: string;
  selected: boolean;
  default: boolean;
}

export interface FilterOptions
{
  showAdvancedFilters: boolean;
  link?: string;
}

export interface Settings
{
  selectPlaceHolder?: string;
  minPlaceHolder?: string;
  maxPlaceHolder?: string;
  pagePlaceHolder?: string;
  orSeparator?: string;
  andSeparator?: string;
  rangeOprator?: string;
  multivalueSeparator?: string;
  language?: string;
  encoder?: Encoder;
  disableCache: boolean;
  maxInitialCacheLevel: number;
  maxValuesCache: number;
  maxDegreeOfParallelism: number;
  defaultRecordsPerPage: number;
  recordsPerPage?: number[];
  defaultSort?: Sort;
  showFilterValuesRecordCounts: boolean;
  filterValuesRecordCountVariants: boolean;
  advancedFiltersAlwaysLast: boolean;
}

export interface Encoder
{
  forceLowerCaseUrl: boolean;
  customUrlEncoding?: { [key: string]: string };
}

export interface Record
{
  productGroupID?: string;
  productType?: string;
  productID?: string;
  productName?: string;
  headerPromotionPrice?: string;
  headerStandardPrice?: string;
  headerPromotionPercent?: number;
  headerPromotionPercentFrom?: boolean;
  headerPriceUnit?: string;
  status?: string;
  badge?: string[];
  productLink?: string; // co
  imageLink?: string;
  previewImageIndex?: number;
  variants?: Variant[];
  headerAttributes?: RecordAttribute[];
  attributes?: RecordAttribute[];
  highlightedProducName?: string;

  // custom
  isCarpet?: boolean;
  isWalkway?: boolean;
  isCovering?: boolean;
  isWiper?: boolean;

  isLastInRow?: boolean;
  listingProductHoverWidth?: number[];
  listingProductHoverHeight?: number[];
}

export class FamilyType
{
  static WYKLADZINA_DYWANOWA: string = "Wykładzina dywanowa";
  static WYKLADZINA_ELASTYCZNA: string = "Wykładzina elastyczna";
  static AKCESORIA_WYCIERACZKI: string = "Wycieraczka";
  static DYWANY: string = "Dywan";
  static CHODNIKI: string = "Chodnik";
  static TRAWA: string = "Sztuczna trawa";
  static WYKLADZINA: string = "Wykładzina";
  static PODUSZKI: string = "Poduszka";
}

export interface Variant
{
  active?: boolean;
  option?: string;
  priceUnit?: string;
  promotionPrice?: string;
  beforePromotionPrice?: string;
  standardPrice?: string;
  deliveryTime?: string;
  deliveryDate?: Date;
  shipmentDate?: Date;
  shipmentTime?: string;
  shipmentTimeShort?: string;
  customAttributes?: { [key: string]: string };
}

export interface RecordAttribute
{
  name?: string;
  code?: string;
  stringValues?: string[];
  decimalValues?: number[];
  decimalValue?: number;
  stringValue?: string;
  stringValueByHash?: { [key: string]: string };
  decimalValueByHash?: { [key: string]: number };
  decimalValueHash: number;
  stringValueHash: number;
  json?: any;
  unit?: string;
}

export interface Paging
{
  currentPage: number;
  pageCount: number;
  recordsPerPage: number;
  totalRecords: number;
  linkTemplate?: string;
  friendlyLinkTemplate: string;
}

export interface SearchQuery
{
  query?: string;
  sort?: string;
  uRL?: string;
  referral?: string;
  currentPage: number;
  recordsPerPage: number;
  advancedFilters: number;
  _Warning?: string;
  shopInstance: number;
  channel?: string;
  filters?: Filter[];
  warning?: string;
  friendlyURL?: string;
}

export interface SuggestResultDTO
{
  searchResult?: SuggestResult;
}

export interface SuggestResult extends RecordsResult
{
  frazes?: string[];
  customSuggest?: CustomSuggest[];
  infoPages?: InfoPage[];
}

export interface CustomSuggest
{
  title?: string;
  frazes?: string[];
}

export interface InfoPage
{
  title?: string;
  content?: string;
}